<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame">
<p class="CN" id="_idParaDest-7" xml:lang="en-GB"><span class="CharOverride-11">Contents</span></p>
<p class="BT-1st ParaOverride-10"><a href="#/eBook_V45578#_idTextAnchor001"><span class="CharOverride-12">PART ONE</span></a><span class="CharOverride-12">: The Infiltration</span></p>
<p class="BT-1st ParaOverride-11"><span href="#/eBook_V455720#_idTextAnchor193" title="Link target outside of Sample"><span class="CharOverride-12">PART TWO</span></span><span class="CharOverride-12">: The Fall of Hue</span></p>
<p class="BT-1st ParaOverride-11"><span href="#/eBook_V455726#_idTextAnchor320" title="Link target outside of Sample"><span class="CharOverride-12">PART THREE</span></span><span class="CharOverride-12">: Futility and Denial</span></p>
<p class="BT-1st ParaOverride-11"><span href="#/eBook_V455734#_idTextAnchor425" title="Link target outside of Sample"><span class="CharOverride-12">PART FOUR</span></span><span class="CharOverride-12">: Counterattack in <br/>the Triangle and Disaster at La Chu</span></p>
<p class="BT-1st ParaOverride-11"><span href="#/eBook_V455744#_idTextAnchor582" title="Link target outside of Sample"><span class="CharOverride-12">PART FIVE</span></span><span class="CharOverride-12">: Sweeping the Triangle</span></p>
<p class="BT-1st ParaOverride-11"><span href="#/eBook_V455755#_idTextAnchor768" title="Link target outside of Sample"><span class="CharOverride-12">PART SIX</span></span><span class="CharOverride-12">: Taking Back the Citadel</span></p>
<p class="BT-1st ParaOverride-11"><span href="#/eBook_V455769#_idTextAnchor986" title="Link target outside of Sample"><span class="CharOverride-12">Epilogue</span></span></p>
<p class="BT-1st ParaOverride-11"><span href="#/eBook_V455770#_idTextAnchor1012" title="Link target outside of Sample"><span class="CharOverride-12">Postscript</span></span></p>
<p class="BT-1st ParaOverride-11"><span href="#/eBook_V455771#_idTextAnchor1013" title="Link target outside of Sample"><span class="CharOverride-12">Acknowledgments</span></span></p>
<p class="BT-1st ParaOverride-11"><span href="#/eBook_V455772#_idTextAnchor1018" title="Link target outside of Sample"><span class="CharOverride-12">Vietnamese Glossary</span></span></p>
<p class="BT-1st ParaOverride-11"><span href="#/eBook_V455773#_idTextAnchor1019" title="Link target outside of Sample"><span class="CharOverride-12">Source Notes</span></span></p>
<p class="BT-1st ParaOverride-12"><span href="#/eBook_V455774#_idTextAnchor1476" title="Link target outside of Sample"><span class="CharOverride-12">Index</span></span></p>
<p class="Map"><img alt="" class="_idGenObjectAttribute-4" src="image/Map1Vietnamcopy.png"/> </p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// eBook_V45576.vue?acfb3904